/** Small animated "…" loading indicator. */
export function LoadingDots() {
  return <span className="loading-dots" aria-label="loading"></span>;
}
